// Which looks a browser may apply (docs/SUPPORTERS.md 8). A look with `release: "YYYY-MM-DD"` is
// hidden until that day, except for supporters, who see it from 30 days before with an "Early"
// tag. A look with `signature: true` is a Supporter look: anyone can try it on for 60 seconds,
// applying it needs the perk. Every look that is free when this ships stays free.
//
// When a locked look is applied, its settings are noted under LOCKED_LOOK_KEY; the app puts the
// last free look back on a later load if the perk has gone (app/supporter-sync.js).

export const LOCKED_LOOK_KEY = "revault:lockedLook";
export const LAST_FREE_LOOK_KEY = "revault:lastFreeLook";
export const LOOK_REVERTED_KEY = "revault:lookReverted";
export const TRY_ON_MS = 60000;
const DAY = 86400000;

// Midnight Eastern on the release day (EST offset; an hour early in summer is fine for a date).
export const releaseAt = (b) => (b && b.release ? Date.parse(b.release + "T05:00:00Z") : 0);

// "free" | "early" (shown early to a supporter) | "signature" (perk on) | "try" (try-on only) | "hidden"
export function lookAccess(b, perks, now = Date.now()) {
	const rel = releaseAt(b);
	if (rel && now < rel) {
		if (!(perks && perks.earlyLooks) || now < rel - 30 * DAY) return "hidden";
		return b.signature ? "signature" : "early";
	}
	if (b.signature) return perks && perks.signatureLooks ? "signature" : "try";
	return "free";
}
export const isLocked = (b, now = Date.now()) => !!(b && (b.signature || releaseAt(b) > now));

function write(key, v) { try { if (v == null) localStorage.removeItem(key); else localStorage.setItem(key, JSON.stringify(v)); } catch (e) { void e; } }
function read(key) { try { return JSON.parse(localStorage.getItem(key) || "null"); } catch (e) { void e; return null; } }
export const noteLocked = (b) => write(LOCKED_LOOK_KEY, { id: b.id, settings: b.settings });
export const noteFree = (settings) => { write(LAST_FREE_LOOK_KEY, settings); write(LOCKED_LOOK_KEY, null); };

// Run on app load with fresh-enough perks. Returns true when it put the free look back.
export function revertLockedLook({ perks, getAll, setMany, fallback }) {
	const locked = read(LOCKED_LOOK_KEY);
	if (!locked || !locked.settings) return false;
	const all = getAll();
	const still = Object.keys(locked.settings).every((k) => all[k] === locked.settings[k]);
	if (!still) { write(LOCKED_LOOK_KEY, null); return false; }
	if (perks.signatureLooks || perks.earlyLooks) return false;
	setMany(read(LAST_FREE_LOOK_KEY) || fallback);
	write(LOCKED_LOOK_KEY, null);
	write(LOOK_REVERTED_KEY, { id: locked.id, at: Date.now() });
	return true;
}
